const KEY = 'lunary.dailyOpened'

export function guestOpened(date: string): boolean {
  try {
    return localStorage.getItem(KEY) === date
  } catch {
    return false
  }
}

export function markGuestOpened(date: string): void {
  try {
    localStorage.setItem(KEY, date)
  } catch {
    return
  }
}
